import { useNavigate } from 'react-router-dom';
import React, { useContext } from 'react';
import { AppContext } from './context/AppContext';
import DragCounter from './DragCounter';

function fullShort(timer) {
    // if (timer < 60) {
    //     return formatSeconds(timer, 1);
    // } else {
    return formatSeconds(timer, 0);
    // }
}

function formatSeconds(seconds, decimalPlaces = 0) {

    // show different times depending on "stuff"
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    // Format minutes and seconds with leading zeros
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    // If decimal places are required, calculate the fractional part
    if (decimalPlaces > 0) {
        // const fractionalSeconds = (remainingSeconds - Math.floor(remainingSeconds)).toFixed(decimalPlaces);
        // return `${formattedMinutes}:${formattedSeconds}${fractionalSeconds.substring(1)}`;
        const fractionalSeconds = Math.floor((seconds - Math.floor(seconds)) * (10 ** decimalPlaces));
        const formattedfractionalSeconds = String(fractionalSeconds).padStart(decimalPlaces, '0');


        // \?).toFixed(decimalPlaces);
        return `${formattedMinutes}:${formattedSeconds}.${formattedfractionalSeconds}`;
    } else {
        return `${formattedMinutes}:${formattedSeconds}`;
    }
}

function DigitalClock(props) {
    const { FLAGS, timer, setTimer, period, running, setRunning } = useContext(AppContext);

    function addTime(e) {
        setTimer(prev => (prev + Number(e.target.value)));
    };
    function subtractTime(e) {
        setTimer(prev => Math.max(prev - Number(e.target.value), 0));
    }
    const navigate = useNavigate();

    return (
        <div className='gridDigitalClockContainer'>
            <div className='gridDigitalClockItem gridColumnWide'>Time</div>
            <div className='gridDigitalClockItem '>Period</div>

            <div id='gameTime' className='gridDigitalClockItem gameTime clockTable digitalNumber XgridColumnWide' >
                <DragCounter value={timer} setValue={setTimer} running={running} setRunning={setRunning}>
                    <span className='gameTime noSelect {props.highlight ? "highlight" : ""}  ' >{fullShort(timer)}</span>
                </DragCounter>
            </div>
            {props.showMicroAdjust ?
                (<span onClick={(event) => event.stopPropagation()} className='gridDigitalCLockItem blankSpace'>{FLAGS.clockMainAdjust ?
                    (<div className='clockMicroAdjustDiv'><button className='clockMicroAdjust plusminusButton' onClick={addTime} value='1' >+</button>
                        <button className='clockMicroAdjust plusminusButton' onClick={subtractTime} value='1' >-</button></div>) : (<div></div>)}</span>)
                : <div></div>}
            <div className='gridDigitalClockItem gameTime clockTable digitalNumber' onClick={() => navigate('/edittime')}>
                <div className='gameTime'>{period}</div >
            </div>
        </div >)

}

export default DigitalClock;